(function () {
  'use strict';

  const STORAGE_KEY = 'cb_selected_city';

  /**
   * Obtém a cidade selecionada do localStorage
   * @returns {string|null} A cidade em maiúsculas (RJ, SP) ou null
   */
  function getSelectedCity() {
    try {
      const city = localStorage.getItem(STORAGE_KEY);
      return city ? city.toUpperCase() : null;
    } catch (error) {
      console.warn('Erro ao ler cidade do localStorage:', error);
      return null;
    }
  }

  /**
   * Verifica se estamos na página de carrinho ou no drawer do carrinho
   * @returns {boolean}
   */
  function isCartPage() {
    return document.querySelector('.shopify-section--main-cart') !== null ||
           document.querySelector('.cart') !== null ||
           document.querySelector('.cart-drawer') !== null ||
           document.querySelector('cart-drawer') !== null ||
           window.location.pathname.includes('/cart');
  }

  /**
   * Valida o estoque de todos os itens no carrinho baseado na cidade selecionada
   */
  function validateCartStock() {
    if (!isCartPage()) {
      return;
    }

    const city = getSelectedCity();
    
    // Se não há cidade selecionada, esconde todos os avisos
    if (!city) {
      const warnings = document.querySelectorAll('.cart-region-warning');
      warnings.forEach(warning => {
        warning.style.display = 'none';
      });
      return;
    }

    // Procura por todos os avisos de região no carrinho
    const warnings = document.querySelectorAll('.cart-region-warning');
    
    warnings.forEach(warning => {
      const outOfStockRJ = warning.getAttribute('data-out-of-stock-rj') === 'true';
      const outOfStockSP = warning.getAttribute('data-out-of-stock-sp') === 'true';
      
      let shouldShow = false;
      
      // Verifica se a cidade atual está sem estoque
      if (city === 'RJ' && outOfStockRJ) {
        shouldShow = true;
      } else if (city === 'SP' && outOfStockSP) {
        shouldShow = true;
      }
      
      // Controla a exibição do aviso
      if (shouldShow) {
        warning.style.display = 'block';
      } else {
        warning.style.display = 'none';
      }
    });
  }

  /**
   * Inicializa o sistema de validação de estoque no carrinho
   */
  function init() {
    // Verifica imediatamente quando o script carrega
    if (isCartPage()) {
      // Pequeno delay para garantir que o DOM está pronto
      setTimeout(function() {
        validateCartStock();
      }, 100);
    }

    // Observa mudanças no localStorage (caso a cidade seja alterada em outra aba)
    window.addEventListener('storage', function (e) {
      if (e.key === STORAGE_KEY) {
        validateCartStock();
      }
    });

    // Observa mudanças na cidade (quando o usuário seleciona uma cidade)
    // Usa um intervalo para verificar mudanças no localStorage
    let lastCity = getSelectedCity();
    const cityCheckInterval = setInterval(function() {
      const currentCity = getSelectedCity();
      if (currentCity !== lastCity) {
        lastCity = currentCity;
        validateCartStock();
      }
    }, 500);

    // Observa o evento customizado quando a cidade é alterada
    window.addEventListener('city:changed', function () {
      validateCartStock();
    });

    // Observa quando o carrinho é atualizado (eventos do tema)
    document.addEventListener('cart:change', function () {
      // Pequeno delay para garantir que o DOM foi atualizado
      setTimeout(function() {
        validateCartStock();
      }, 300);
    });

    // Observa quando um item específico é alterado
    document.addEventListener('line-item:change', function () {
      setTimeout(function() {
        validateCartStock();
      }, 300);
    });

    // Observa quando uma variante é adicionada
    document.addEventListener('variant:add', function () {
      setTimeout(function() {
        validateCartStock();
      }, 300);
    });

    // Observa mudanças no DOM que podem indicar atualização do carrinho
    // Útil quando itens são adicionados/removidos via AJAX
    const cartObserver = new MutationObserver(function(mutations) {
      let cartChanged = false;
      
      mutations.forEach(function(mutation) {
        // Verifica se há mudanças nos line items
        if (mutation.type === 'childList') {
          const addedNodes = Array.from(mutation.addedNodes);
          const removedNodes = Array.from(mutation.removedNodes);
          
          // Verifica se algum nó adicionado/removido é um line-item ou cart-region-warning
          const hasLineItem = addedNodes.some(node => 
            node.nodeType === 1 && (
              node.classList?.contains('line-item') ||
              node.classList?.contains('cart-region-warning') ||
              node.querySelector?.('.cart-region-warning') ||
              node.querySelector?.('.line-item')
            )
          ) || removedNodes.some(node => 
            node.nodeType === 1 && (
              node.classList?.contains('line-item') ||
              node.classList?.contains('cart-region-warning')
            )
          );
          
          if (hasLineItem) {
            cartChanged = true;
          }
        }
      });
      
      if (cartChanged) {
        // Pequeno delay para garantir que o DOM foi atualizado completamente
        setTimeout(function() {
          validateCartStock();
        }, 200);
      }
    });

    // Observa mudanças no container do carrinho
    const cartContainer = document.querySelector('.cart') || 
                          document.querySelector('.order-summary__body') ||
                          document.querySelector('.cart-drawer__line-items') ||
                          document.querySelector('cart-drawer') ||
                          document.querySelector('cart-notification-drawer');
    
    if (cartContainer) {
      cartObserver.observe(cartContainer, {
        childList: true,
        subtree: true
      });
    }
  }

  // Inicializa quando o DOM estiver pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
